import React, { useState } from "react";
import lightIcon from "../../assets/icons/lightIcon.svg";
import ProfileProgress from "../common/ProfileProgress";
import StatCard from "../common/StateCard";
import StarsIcon from "../../assets/icons/starsIcon.svg";
import CalenderIcon from "../../assets/icons/calenderIcon.svg";
import TimeIcon from "../../assets/icons/timeicon.svg";
import { DayPicker, getDefaultClassNames } from "react-day-picker";
import "react-day-picker/style.css";
import { useNavigate } from "react-router-dom";

function CandidateDashboard() {
  const [selected, setSelected] = useState(null);
  const defaultClassNames = getDefaultClassNames();
  const navigate = useNavigate();

  const [stats, setStats] = useState({
    activeJobs: { count: 2420, change: 40 },
    shortlisted: { count: 1210, change: -10 },
    timeToHire: { count: 64, change: 20 },
  });

  const [scheduledInterviews, setScheduledInterviews] = useState([
    {
      id: 1,
      name: "Morph & Mind",
      email: "hi@siennahewitt.com",
      position: "Frontend Developer",
      status: "Submitted",
      avatar: "../../assets/Avatar2.png",
    },
    {
      id: 2,
      name: "Ammar Foley",
      email: "ammarfoley@gmail.com",
      position: "Product Manager",
      status: "Shortlisted",
      avatar: "../../assets/Avatar3.png",
    },
    {
      id: 3,
      name: "Pippa Wilkinson",
      email: "pippa@pippaw.com",
      position: "UX/UI Designer",
      status: "Active",
      avatar: "../../assets/Avatar4.png",
    },
  ]);

  const interviewTimes = [
    {
      id: 1,
      title: "Interview 1",
      timeFrom: "1:30 PM",
      timeTo: "3:30 PM",
      date: "Jan 10, 2025",
      avatar: "../../assets/Avatar3.png",
    },
    {
      id: 2,

      title: "Interview 2",
      timeFrom: "1:30 PM",
      timeTo: "3:30 PM",
      date: "Jan 10, 2025",
      avatar: "../../assets/Avatar3.png",
    },
    {
      id: 3,
      title: "Interview 3",
      timeFrom: "1:30 PM",
      timeTo: "3:30 PM",
      date: "Jan 10, 2025",
      avatar: "../../assets/Avatar3.png",
    },
  ];

  return (
    <section className="flex flex-col gap-10">
      <div className="flex sm:flex-row flex-col gap-6 justify-between items-start">
        <div className="flex gap-4 items-center">
          <div>
            <ProfileProgress />
          </div>

          <div className="flex flex-col gap-1 items-start">
            <h2 className="text-gray-800 font-semibold sm:text-2xl text-lg">
              Welcome back, Olivia
            </h2>
            <p className="text-gray-400 sm:text-sm text-xs font-medium">
              Here is a complete overview of your jobs.
            </p>
            <button className="mt-4 flex items-center gap-2 px-2 py-1.5 border border-gray-300 rounded-md text-gray-500 text-xs font-bold hover:bg-gray-100 transition duration-200 cursor-pointer">
              <img src={lightIcon} alt="lightIcon" className="w-4 h-4" />
              Add your credentials
            </button>
          </div>
        </div>

        <div className="flex gap-3 items-center">
          <butoon
            className="text-gray-700 px-3 py-2 border text-sm font-semibold border-gray-300 rounded-lg cursor-pointer"
            onClick={() => navigate("/candidate/userprofile")}
          >
            Edit Profile
          </butoon>
          <butoon className="text-white px-3 py-2 bg-[#19BFB7] text-sm font-semibold rounded-lg cursor-pointer" onClick={() => navigate("/candidate/jobs")}>
            Browse Jobs
          </butoon>
        </div>
      </div>

      {/* Statistics Cards */}
      <div className="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-6 mb-6">
        <StatCard
          title="Total Jobs Applied"
          count={stats.activeJobs.count}
          change={stats.activeJobs.change}
          trend="M0 45L20 35L40 40L60 30L80 35L100 25L120 30L140 20L160 25L180 15L200 20"
        />
        <StatCard
          title="Active Job Applications"
          count={stats.shortlisted.count}
          change={stats.shortlisted.change}
          trend="M0 20L20 25L40 20L60 25L80 30L100 25L120 30L140 35L160 40L180 45L200 50"
        />
        <StatCard
          title="Response Rate"
          count={
            stats.timeToHire.weeks
              ? `${stats.timeToHire.weeks}`
              : stats.timeToHire.count
          }
          change={stats.timeToHire.change}
          trend="M0 30L20 25L40 35L60 30L80 40L100 35L120 45L140 40L160 50L180 45L200 55"
          suffix="%"
        />
      </div>

      {/*  */}
      <div className="lg:grid lg:grid-cols-3 flex flex-col gap-6">
        <div className="lg:col-span-2">
          <div className="border border-gray-300 rounded-lg bg-gray-50 ">
            <h1 className="text-sm text-gray-800 font-semibold flex items-center gap-2 px-4 py-2">
              <span>
                <img className="w-4 h-4" src={StarsIcon} alt="stars icon" />
              </span>
              AI Suggestions
            </h1>
            <div className="px-4 py-2 pb-8 border-gray-300 rounded-t-lg border-y bg-white">
              <div className="">
                <div className="flex items-end flex-col gap-3 ">
                  <h3 className="text-gray-800 font-semibold text-sm">
                    Increase Application Volume & Quality –{" "}
                    <span className="text-gray-400 text-sm font-medium">
                      Apply to at least X jobs per week, but prioritize roles
                      that closely match your skills and experience. Personalize
                      applications with a short, impactful cover letter.
                    </span>
                  </h3>

                  <button className="cursor-pointer text-gray-800 text-xs font-semibold flex items-center gap-1">
                    Apply
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 25 25"
                      className="w-4 h-4"
                    >
                      <path
                        d="m17.5 5.999-.707.707 5.293 5.293H1v1h21.086l-5.294 5.295.707.707L24 12.499l-6.5-6.5z"
                        data-name="Right"
                      />
                    </svg>
                  </button>
                </div>

                {/*  */}
                <div className="flex items-end flex-col gap-3 mt-6">
                  <h3 className="text-gray-800 font-semibold text-sm">
                    Increase Application Volume & Quality –{" "}
                    <span className="text-gray-400 text-sm font-medium">
                      Apply to at least X jobs per week, but prioritize roles
                      that closely match your skills and experience. Personalize
                      applications with a short, impactful cover letter.
                    </span>
                  </h3>

                  <button className="cursor-pointer text-gray-800 text-xs font-semibold flex items-center gap-1">
                    Apply
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 25 25"
                      className="w-4 h-4"
                    >
                      <path
                        d="m17.5 5.999-.707.707 5.293 5.293H1v1h21.086l-5.294 5.295.707.707L24 12.499l-6.5-6.5z"
                        data-name="Right"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            <div className="w-full bg-white px-4 py-4 rounded-b-lg">
              <button className="cursor-pointer w-full text-[#009C97] text-xs font-semibold flex items-center justify-end gap-1">
                Apply All
                <span className="flex items-center justify-center ">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 25 25"
                    className="w-4 h-4"
                  >
                    <path
                      d="m17.5 5.999-.707.707 5.293 5.293H1v1h21.086l-5.294 5.295.707.707L24 12.499l-6.5-6.5z"
                      fill="#009C97"
                      data-name="Right"
                    />
                  </svg>
                </span>
              </button>
            </div>
          </div>

          {/* bottom table */}
          <div>
            <div className=" bg-white rounded-xl border border-gray-200 mt-10">
              <div className="bg-gray-50 py-3 px-5">
                <h3 className="text-lg font-semibold text-gray-900">
                  Active Applications
                </h3>
              </div>
              {/* <div className="flex gap-3 items-end  py-4 px-5 border-y border-gray-200 rounded-t-md">
                <h3 className="text-2xl text-gray-900 font-semibold">120</h3>
                <div className="flex items-center gap-1 text-sm text-emerald-600">
                  <span>↑ 8.6%</span>
                  <span className="text-gray-600 ml-1">vs last 30 days</span>
                </div>
              </div> */}

              <div className=" ">
                <div className="px-5 py-3 grid md:grid-cols-5 grid-cols-4  border-b border-gray-200">
                  <div className="flex gap-3 items-center md:col-span-3 col-span-2">
                    <input
                      type="checkbox"
                      className="rounded border-gray-300 text-sm sm:block hidden"
                    />
                    <h5 className="text-gray-500 font-semibold sm:text-sm text-xs">
                      Company
                    </h5>
                  </div>

                  <div className="grid grid-cols-2 col-span-2 ">
                    <h5 className="text-gray-500 font-semibold  sm:text-sm text-xs ">
                      Position Applied
                    </h5>

                    <h5 className="text-gray-500 font-semibold  sm:text-sm text-xs">
                      Status
                    </h5>
                  </div>
                </div>

                {scheduledInterviews.map((interview) => (
                  <div
                    key={interview.id}
                    className="grid md:grid-cols-5 grid-cols-4  items-center p-4 border-b border-gray-200"
                  >
                    {/* <input type="checkbox" className="rounded border-gray-300" /> */}
                    <div className="flex items-center gap-3 md:col-span-3 col-span-2">
                      <input
                        type="checkbox"
                        className="rounded border-gray-300 sm:block hidden"
                      />

                      <img
                        src={interview.avatar}
                        alt=""
                        className="w-10 h-10 rounded-full md:block hidden"
                      />
                      <div>
                        <p className="font-medium text-gray-900 sm:text-lg text-sm">
                          {interview.name}
                        </p>
                        <p className="sm:text-sm text-xs text-gray-500">
                          {interview.email}
                        </p>
                      </div>
                    </div>
                    <div className="">
                      <p className="font-medium sm:text-sm text-xs text-gray-500">
                        {interview.position}
                      </p>
                    </div>

                    <div className=" w-full flex items-center md:justify-between md:gap-0 gap-2 sm:mr-3">
                      <span
                        className={`font-medium  text-center md:text-[11px] sm:text-[10px] text-[9px] ${
                          interview.status === "Active" ||
                          interview.status === "Shortlisted"
                            ? "bg-green-100 border border-green-400 text-green-600"
                            : interview.status === "Submitted"
                            ? "bg-blue-100 text-blue-600 border border-blue-400"
                            : ""
                        }  md:py-2 py-1 md:px-3 px-2 rounded-lg  `}
                      >
                        {interview.status}
                      </span>
                      <span className="text-gray-600 cursor-pointer md:text-xl text-md font-bold sm:block hidden">
                        &#8942;
                      </span>
                    </div>
                  </div>
                ))}

                <div className="px-5 py-4 flex items-center justify-between ">
                  <div>
                    <p className="text-md font-semibold text-gray-900">
                      Page <span>1</span> of <span>4</span>
                    </p>
                  </div>
                  <div className="flex gap-5 items-center">
                    <button className="text-sm text-gray-900 py-2 px-3 hover:bg-gray-50 duration-200  cursor-pointer border border-gray-200 rounded-lg">
                      Previous
                    </button>
                    <button className="text-sm text-gray-900 py-2 px-3  hover:bg-gray-50 duration-200 cursor-pointer  border border-gray-200 rounded-lg">
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* calender */}
        <div className="bg-gray-50 rounded-lg border-gray-300 border flex flex-col">
          <h1 className="text-sm text-gray-800 font-semibold flex items-center gap-2 px-4 py-2">
            Scheduled Interviews
          </h1>
          <div className="bg-white px-6 rounded-t-lg border-y border-gray-300 py-4 w-full">
            <div className="flex items-center justify-center border border-gray-200 rounded-lg p-4 w-full">
              <DayPicker
                animate
                showOutsideDays
                mode="single"
                selected={selected}
                onSelect={setSelected}
                classNames={{
                  today: "text-blue-500",
                  day: "text-black text-sm font-semibold",
                  selected: "text-white bg-[#19BFB7] rounded-full ",
                  weekdays: "text-gray-800 font-semibold",
                  outside: "text-gray-300",
                  month_caption: "text-gray-800 font-semibold",
                }}
                footer={
                  // selected
                  //   ? `Selected: ${selected.toLocaleDateString()}`
                  //   : "Pick a day."
                  false
                }
              />
            </div>
          </div>

          <div className="bg-white flex flex-col justify-between rounded-b-lg py-3">
            <div>
              {interviewTimes.map((interview) => (
                <div
                  key={interview.id}
                  className="flex items-center gap-3 px-6 py-4"
                >
                  <img
                    src={interview.avatar}
                    alt="avatar"
                    className="rounded-full border border-gray-100 w-10 h-10"
                  />
                  <div>
                    <h3 className=" text-lg font-semibold text-gray-800">
                      {interview.title}
                    </h3>
                    <p className="text-gray-500 text-xs font-medium flex gap-2 items-center">
                      <span className="flex gap-1 items-center">
                        <img
                          src={CalenderIcon}
                          alt="calender icon"
                          className="w-4 h-4"
                        />
                        {interview.date}
                      </span>
                      <span className="flex items-center gap-1">
                        <img
                          src={TimeIcon}
                          alt="time icon"
                          className="w-4 h-4"
                        />
                        {interview.timeFrom}-{interview.timeTo}
                      </span>
                    </p>
                  </div>
                </div>
              ))}
            </div>
            <div className="flex items-center justify-between px-4 py-2">
              <h4 className="text-gray-800 font-semibold text-xs flex items-center gap-1 ">
                Page <span>1</span> of <span>4</span>
              </h4>
              <div className="flex items-center gap-3">
                <button className="text-gray-700 font-semibold text-xs py-1.5 px-2.5 rounded-lg border border-gray-300 cursor-pointer hover:bg-gray-100 transition duration-150 ">
                  Pervious
                </button>
                <button className="text-gray-700 font-semibold text-xs py-1.5 px-2.5 rounded-lg border border-gray-300 cursor-pointer hover:bg-gray-100 transition duration-150">
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CandidateDashboard;
